import React, { useRef, useState, useEffect } from 'react';

import useOutsideClick from '@stencil/use-outside-click';
import CalendarBlock from './calendar-block';
import { __GOIBIBO__, FLIGHTS_URL } from '@stencil/flights-constants/src/urls';
import NoFlightFound from '../Common/no-flight-found';
import TopBannerSection from './top-banner-section';
import LoadingDetailsSection from './loading-details-section';
import SortBySection from './sort-by-section';
import FlightCard from './flight-card';

import * as S from './details-section.styles';

const DetailsSection = props => {
  const {
    destination,
    departure,
    cityRef,
    countryRef,
    detailsDestinations = [],
    countryTravelGuidelines,
    sortFlightsSettings,
    applySortFlightsSettings,
    getFareData,
    fareCalendarData,
    calendarDateChanged,
    handleCloseDtlSection,
    handleDateSelection,
    handleFlightSelection,
    showDtlSection,
    isRoundTrip = true,
    isVisibleCalendar,
    setVisibleCalendar,
    queryParam
  } = props;

  useEffect(() => {
    if (document && document.body) {
      if (isVisibleCalendar) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = 'unset';
      }
    }
  }, [isVisibleCalendar]);

  const [showLoader, setShowLoader] = useState(true);
  const [showError, setShowError] = useState(false);

  const [showSortby, setsortBy] = useState(
    sortFlightsSettings?.currentSort === 'cheapest' ? 'CHEAPEST' : 'SHORTEST'
  );
  const [showSortAsc, setSortOrder] = useState(props?.sortFlightsSettings?.isAscending);
  const [active, setActive] = useState(false);
  const [numberOfFlights, setNumberOfFlights] = useState(10);
  const [totalNumberOfFlights, setTotalNumberOfFlights] = useState(
    detailsDestinations && detailsDestinations.length
  );
  const [calendarMode, setCalendarMode] = useState('');
  const calendarBlockRef = React.createRef();
  const sortByRef = useRef();
  const flightCardRef = React.createRef();

  useEffect(() => {
    setsortBy(sortFlightsSettings?.currentSort.toUpperCase());
    setSortOrder(sortFlightsSettings?.isAscending);
  }, [sortFlightsSettings.currentSort, sortFlightsSettings.isAscending]);

  useEffect(() => {
    // Destinations not available with applied filters
    if (detailsDestinations === null) {
      setShowLoader(true);
    }
    if (detailsDestinations && detailsDestinations.length == 0) {
      setShowError(true);
    }
    if (detailsDestinations && detailsDestinations.length > 0) {
      setShowLoader(false);
      setShowError(false);
      setTotalNumberOfFlights(detailsDestinations.length);
    }
    if (flightCardRef && flightCardRef?.current?.scrollIntoView) {
      flightCardRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  }, [detailsDestinations]);

  useOutsideClick(calendarBlockRef, () => {
    setCalendarMode('');
  });

  const sortByHandle = e => {
    setsortBy(e);
    setActive(false);
  };

  const handleActive = () => {
    setActive(!active);
  };

  useOutsideClick(sortByRef, () => {
    setActive(false);
  });

  const viewAllFlights = () => {
    window.open(`${__GOIBIBO__}${FLIGHTS_URL}${queryParam}`);
  };

  return (
    <S.ListingSection className={showDtlSection != null ? 'openedState' : ''}>
      <S.TopBannerSection
        className={
          destination.covid_status === 'OPEN'
            ? 'open'
            : destination.covid_status === 'CLOSED'
            ? 'closed'
            : destination.covid_status === 'PARTIALLYOPEN'
            ? 'partiallyOpen'
            : 'open'
        }
      >
        <TopBannerSection
          destination={destination}
          cityRef={cityRef}
          countryRef={countryRef}
          countryTravelGuidelines={countryTravelGuidelines}
        />
      </S.TopBannerSection>
      <S.Container>
        {showLoader || !showError ? (
          <>
            <S.SortBySection ref={flightCardRef}>
              <div className="dF alignItemsCenter justifyBetween marginB10">
                <span className="backBtn black quicksand fb font10">
                  <span onClick={handleCloseDtlSection} style={{ paddingRight: '0.5rem' }}>
                    <span className="arrow"></span>
                    <span className="arrow"></span>
                  </span>
                  Showing {isRoundTrip ? 'ROUND-TRIP' : 'ONE-WAY'} Fares ON
                </span>
                <CalendarBlock
                  ref={calendarBlockRef}
                  isSearchWidget={true}
                  isDeparture={!isRoundTrip}
                  isArrival={false}
                  onSelection={() => setCalendarMode('')}
                  handleOnDateClick={handleDateSelection}
                  departure={departure}
                  getFareData={getFareData}
                  calendarDateChanged={calendarDateChanged}
                  fareCalendarData={fareCalendarData}
                  isVisibleCalendar={isVisibleCalendar}
                  setVisibleCalendar={setVisibleCalendar}
                />
              </div>
              <SortBySection
                active={active}
                handleActive={handleActive}
                showSortby={showSortby}
                setSortOrder={setSortOrder}
                sortByHandle={sortByHandle}
                showSortAsc={showSortAsc}
                applySortFlightsSettings={applySortFlightsSettings}
              />
            </S.SortBySection>
            {showLoader ? (
              <S.ListingOuter>
                {[...Array(10)].map((item, index) => (
                  <LoadingDetailsSection key={index} />
                ))}
              </S.ListingOuter>
            ) : (
              <S.ListingOuter className="marginB10">
                {detailsDestinations &&
                  detailsDestinations
                    .slice(0, numberOfFlights)
                    .map((item, index) => (
                      <FlightCard
                        key={index}
                        handleFlightSelection={handleFlightSelection}
                        flightItem={item}
                      />
                    ))}
                {totalNumberOfFlights !== numberOfFlights && totalNumberOfFlights >= 10 ? (
                  <p className="TxtCenter marginB10 marginT10 curPointFlt">
                    <span className="viewAllfliBtn" onClick={viewAllFlights}>
                      View All Flights
                    </span>
                  </p>
                ) : null}
              </S.ListingOuter>
            )}
          </>
        ) : (
          <NoFlightFound handleCloseDtlSection={handleCloseDtlSection} />
        )}
      </S.Container>
    </S.ListingSection>
  );
};

export default DetailsSection;
